import { render, staticRenderFns } from "./BasketballCover_c1.vue?vue&type=template&id=4f37ca0e&"
import script from "./BasketballCover_c1.vue?vue&type=script&lang=js&"
export * from "./BasketballCover_c1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports